var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "exampleModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalLabel",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg create-encounter-modal mt-0 mb-0",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body p-0" }, [
              _vm.isrefreshpre
                ? _c("div", { attrs: { id: "cover-spin" } })
                : _vm._e(),
              _c("div", { staticClass: "pb-3 pr-5 pl-5 pt-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "row",
                    staticStyle: { "max-width": "898px", margin: "0 auto" },
                  },
                  [
                    _c("div", { staticClass: "col-md-12 px-0" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.getPdfUrl) +
                          " " +
                          _vm._s(_vm.getdatafromparent) +
                          "\n              "
                      ),
                      _c(
                        "ul",
                        { staticClass: "print-export new-rule-border" },
                        [
                          _c("li", [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.onPrintPrescription()
                                  },
                                },
                              },
                              [
                                _c(
                                  "i",
                                  { staticClass: "material-icons print" },
                                  [_vm._v("print")]
                                ),
                              ]
                            ),
                          ]),
                          _vm.$route.name == "staffdashboard"
                            ? _c(
                                "li",
                                {
                                  staticStyle: {
                                    "border-right": "1px solid #eeeeee",
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        "data-target": "#Sendemailp",
                                        "data-toggle": "modal",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showEmailPopup()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("email")]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("li", { staticClass: "mt-1" }, [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "10px" } },
                              [
                                _vm.printable_header
                                  ? _c("span", [_vm._v(_vm._s(_vm.$t("Hide")))])
                                  : _vm._e(),
                                !_vm.printable_header
                                  ? _c("span", [_vm._v(_vm._s(_vm.$t("Show")))])
                                  : _vm._e(),
                                _vm._v(
                                  _vm._s(_vm.$t("Header")) +
                                    "\n                  "
                                ),
                              ]
                            ),
                            _c(
                              "label",
                              { staticClass: "container customcheck pr-1" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.printable_header,
                                      expression: "printable_header",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: "printableheader",
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.printable_header)
                                      ? _vm._i(_vm.printable_header, null) > -1
                                      : _vm.printable_header,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.storeprintableheader()
                                    },
                                    change: function ($event) {
                                      var $$a = _vm.printable_header,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.printable_header = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.printable_header = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.printable_header = $$c
                                      }
                                    },
                                  },
                                }),
                                _c("span", { staticClass: "checkmark" }),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._m(0),
                    ]),
                    _vm.prescriptionobj ||
                    _vm.prescriptionobj != null ||
                    _vm.prescriptionobj != undefined
                      ? _c(
                          "div",
                          {
                            style: { fontFamily: this.$t("fontfam") },
                            attrs: {
                              id: "modallistViewvdPrescriptionDetailsPrint",
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.getsignaturepath) +
                                " " +
                                _vm._s(_vm.getDownloadUrl) +
                                "\n              "
                            ),
                            _c(
                              "HeaderWrapper",
                              { attrs: { printable: _vm.printable_header } },
                              [
                                _c("div", { staticClass: "clinic-logo-hold" }, [
                                  _vm.ClicnicUrllogo != "" &&
                                  _vm.printable_header
                                    ? _c("img", {
                                        attrs: {
                                          src: _vm.ClicnicUrllogo,
                                          height: "85px",
                                          width: "Auto",
                                        },
                                      })
                                    : _vm._e(),
                                ]),
                                _vm.printable_header
                                  ? _c(
                                      "table",
                                      {
                                        staticStyle: { "margin-top": "15px" },
                                        attrs: {
                                          width: "100%",
                                          cellspacing: "0",
                                          cellpadding: "0",
                                          border: "0",
                                        },
                                      },
                                      [
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              padding: "0px 40px",
                                              "background-color":
                                                "rgb(255, 255, 255)",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "wrapper1",
                                                staticStyle: {
                                                  "padding-bottom": "10px",
                                                },
                                                attrs: {
                                                  width: "50%",
                                                  valign: "top",
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    attrs: {
                                                      width: "100%",
                                                      cellspacing: "0",
                                                      cellpadding: "0",
                                                      border: "0",
                                                    },
                                                  },
                                                  [
                                                    _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            display: "block",
                                                            margin: "0",
                                                          },
                                                          attrs: {
                                                            valign: "top",
                                                            align: "right",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color:
                                                                  "#212529",
                                                                "font-size":
                                                                  "14px",
                                                                "font-weight":
                                                                  "500",
                                                                "line-height":
                                                                  "140%",
                                                              },
                                                              attrs: {
                                                                align: "right",
                                                              },
                                                            },
                                                            [
                                                              _vm
                                                                .prescriptionobj
                                                                .staffDetails &&
                                                              _vm
                                                                .prescriptionobj
                                                                .staffDetails
                                                                .title &&
                                                              _vm
                                                                .prescriptionobj
                                                                .staffDetails
                                                                .first_name
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      attrs: {
                                                                        id: "label_doctorname",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .prescriptionobj
                                                                              .staffDetails
                                                                              .title
                                                                          ) +
                                                                          "\n                                " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .prescriptionobj
                                                                              .staffDetails
                                                                              .first_name
                                                                          ) +
                                                                          "\n                                " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .prescriptionobj
                                                                              .staffDetails
                                                                              .last_name ==
                                                                              null
                                                                              ? ""
                                                                              : _vm
                                                                                  .prescriptionobj
                                                                                  .staffDetails
                                                                                  .last_name
                                                                          ) +
                                                                          "\n                              "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color:
                                                                  "#212529",
                                                                "font-size":
                                                                  "14px",
                                                                "font-weight":
                                                                  "500",
                                                                "line-height":
                                                                  "140%",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.qualification
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color:
                                                                  "#212529",
                                                                "max-width":
                                                                  "50% !important",
                                                                display:
                                                                  "block",
                                                                "font-size":
                                                                  "14px",
                                                                "font-weight":
                                                                  "500",
                                                                "line-height":
                                                                  "140%",
                                                              },
                                                              attrs: {
                                                                align: "right",
                                                              },
                                                            },
                                                            [
                                                              _vm.prescriptionobj &&
                                                              _vm
                                                                .prescriptionobj
                                                                .staffDetails &&
                                                              _vm
                                                                .prescriptionobj
                                                                .staffDetails
                                                                .category_list
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      attrs: {
                                                                        id: "label_quilification",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .prescriptionobj
                                                                            .staffDetails
                                                                            .category
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                          _vm.location_tephonedetails
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#212529",
                                                                    "font-size":
                                                                      "14px",
                                                                    "font-weight":
                                                                      "500",
                                                                    "line-height":
                                                                      "140%",
                                                                  },
                                                                  attrs: {
                                                                    align:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.location_tephonedetails
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm.location_tephonedetails
                                                            ? _c("br")
                                                            : _vm._e(),
                                                          _vm.prescriptionobj
                                                            .businessappintmenturl &&
                                                          _vm.prescriptionobj
                                                            .businessappintmenturl !=
                                                            "null" &&
                                                          !_vm.IsVS
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#212529",
                                                                    "font-size":
                                                                      "14px",
                                                                    "font-weight":
                                                                      "500",
                                                                    "line-height":
                                                                      "140%",
                                                                  },
                                                                  attrs: {
                                                                    align:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      ref: "Mini-site URL",
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "rgb(33, 37, 41)",
                                                                          "text-decoration":
                                                                            "none",
                                                                        },
                                                                      attrs: {
                                                                        target:
                                                                          "_blank",
                                                                        href:
                                                                          "https://" +
                                                                          _vm
                                                                            .prescriptionobj
                                                                            .businessappintmenturl,
                                                                        title:
                                                                          "Mini-site URL",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.prescriptionobj.businessappintmenturl.split(
                                                                            "/"
                                                                          )[0]
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "table",
                              {
                                attrs: {
                                  cellspacing: "0",
                                  cellpadding: "0",
                                  width: "100%",
                                },
                              },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("td", [
                                      _c("div", {
                                        class: _vm.printable_header
                                          ? "page-header-space"
                                          : "page-header-nospace",
                                      }),
                                    ]),
                                  ]),
                                ]),
                                _c("tbody", { staticStyle: { border: "0" } }, [
                                  _c("tr", [
                                    _c("td", [
                                      _c("div", { staticClass: "page" }, [
                                        _c(
                                          "table",
                                          {
                                            staticStyle: {
                                              "border-bottom":
                                                "solid 1px #ccc !important",
                                            },
                                            attrs: {
                                              width: "100%",
                                              cellspacing: "0",
                                              cellpadding: "0",
                                              border: "0",
                                            },
                                          },
                                          [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "wrapper1",
                                                  staticStyle: {
                                                    border: "0 !important",
                                                  },
                                                  attrs: {
                                                    width: "70%",
                                                    valign: "top",
                                                    align: "left",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "table",
                                                    {
                                                      attrs: {
                                                        width: "100%",
                                                        cellspacing: "0",
                                                        cellpadding: "0",
                                                        border: "0",
                                                      },
                                                    },
                                                    [
                                                      _c("tr", [
                                                        _vm.prescriptionobj
                                                          .patientdetails
                                                          ? _c(
                                                              "td",
                                                              {
                                                                staticStyle: {
                                                                  padding:
                                                                    "10px 0",
                                                                  border:
                                                                    "0 !important",
                                                                },
                                                                attrs: {
                                                                  valign: "top",
                                                                  align: "left",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "block",
                                                                        float:
                                                                          "left",
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-weight":
                                                                              "500",
                                                                            "font-size":
                                                                              "14px",
                                                                            "line-height":
                                                                              "170%",
                                                                            width:
                                                                              "136px",
                                                                            display:
                                                                              "inline-block",
                                                                            float:
                                                                              "left",
                                                                          },
                                                                        attrs: {
                                                                          id: "label_patientname",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "Patientname"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm
                                                                      .prescriptionobj
                                                                      .patientdetails &&
                                                                    _vm
                                                                      .prescriptionobj
                                                                      .patientdetails
                                                                      .name
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                "font-weight":
                                                                                  "400",
                                                                                color:
                                                                                  "#333333",
                                                                                width:
                                                                                  "auto",
                                                                              },
                                                                            attrs:
                                                                              {
                                                                                id: "value_patientname",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                        :\n                                        " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .prescriptionobj
                                                                                    .patientdetails
                                                                                    .name
                                                                                ) +
                                                                                "\n                                      "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "block",
                                                                        float:
                                                                          "left",
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-weight":
                                                                              "500",
                                                                            "font-size":
                                                                              "14px",
                                                                            "line-height":
                                                                              "170%",
                                                                            width:
                                                                              "136px",
                                                                            display:
                                                                              "inline-block",
                                                                            float:
                                                                              "left",
                                                                          },
                                                                        attrs: {
                                                                          id: "label_registrationno",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "RegistrationNo"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-weight":
                                                                              "400",
                                                                            color:
                                                                              "#333333",
                                                                            width:
                                                                              "auto",
                                                                          },
                                                                        attrs: {
                                                                          id: "value_registrationno",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                        :\n                                        " +
                                                                            _vm._s(
                                                                              _vm.formatRegId(
                                                                                _vm
                                                                                  .prescriptionobj
                                                                                  .patientdetails
                                                                                  .patient_RegId
                                                                              )
                                                                            ) +
                                                                            "\n                                      "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "block",
                                                                        float:
                                                                          "left",
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-weight":
                                                                              "500",
                                                                            "font-size":
                                                                              "14px",
                                                                            "line-height":
                                                                              "170%",
                                                                            width:
                                                                              "136px",
                                                                            display:
                                                                              "inline-block",
                                                                            float:
                                                                              "left",
                                                                          },
                                                                        attrs: {
                                                                          id: "label_agesex",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "AgeSex"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-weight":
                                                                              "400",
                                                                            color:
                                                                              "#333333",
                                                                            width:
                                                                              "auto",
                                                                          },
                                                                        attrs: {
                                                                          id: "value_agesex",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                        :\n                                        "
                                                                        ),
                                                                        _vm.ageCalculated
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.ageCalculated
                                                                                  ) +
                                                                                    " /"
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm
                                                                          .prescriptionobj
                                                                          .patientdetails
                                                                          .gender
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "c_name",
                                                                                staticStyle:
                                                                                  {
                                                                                    "text-transform":
                                                                                      "capitalize",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                          " +
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .prescriptionobj
                                                                                        .patientdetails
                                                                                        .gender
                                                                                    ) +
                                                                                    "\n                                        "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "table",
                                          {
                                            staticClass: "wrapper",
                                            staticStyle: {
                                              float: "left",
                                              width: "100%",
                                            },
                                            attrs: {
                                              width: "100%",
                                              border: "0",
                                              cellspacing: "0",
                                              cellpadding: "0",
                                            },
                                          },
                                          [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "wrapper",
                                                  staticStyle: {
                                                    padding: "10px 0 5px 0",
                                                  },
                                                  attrs: {
                                                    align: "left",
                                                    valign: "top",
                                                    bgcolor: "#FFFFFF",
                                                  },
                                                },
                                                [
                                                  _vm.prescriptionobj
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-text",
                                                          staticStyle: {
                                                            color: "#212529",
                                                            "font-size": "14px",
                                                            "line-height":
                                                              "140%",
                                                            "text-transform":
                                                              "capitalize",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "500",
                                                              },
                                                              attrs: {
                                                                id: "label_date",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t("Date")
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "\n                                " +
                                                              _vm._s(
                                                                _vm
                                                                  .prescriptionobj
                                                                  .modalencounterdate
                                                              ) +
                                                              "\n                              "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]),
                                            _vm._m(1),
                                          ]
                                        ),
                                        _c(
                                          "table",
                                          {
                                            staticClass: "table-print",
                                            staticStyle: {
                                              "border-bottom":
                                                "1px solid #666666",
                                              background: "#ffffff",
                                              width: "100%",
                                              "table-layout": "fixed",
                                            },
                                            attrs: {
                                              cellpadding: "0",
                                              cellspacing: "0",
                                            },
                                          },
                                          [
                                            _c("tr", [
                                              _c("td", [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "listview-table",
                                                  },
                                                  [
                                                    _c("tr", [
                                                      _c(
                                                        "th",
                                                        {
                                                          attrs: { id: "th1" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "MedicineName"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                    _vm._l(
                                                      _vm.prescriptionobj
                                                        .modalresultPrescriptions,
                                                      function (item) {
                                                        return _c(
                                                          "tr",
                                                          { key: item.itemId },
                                                          [
                                                            _c("td", [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "preview-drag-modal",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "preview-drag-block",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "drag-main-block",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "drag-block",
                                                                              staticStyle:
                                                                                {
                                                                                  "padding-bottom":
                                                                                    "10px",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "top",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    [
                                                                                      item.groupType ==
                                                                                      "Medicines"
                                                                                        ? _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-stethoscope",
                                                                                              attrs:
                                                                                                {
                                                                                                  "aria-hidden":
                                                                                                    "true",
                                                                                                },
                                                                                            }
                                                                                          )
                                                                                        : _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-heart-o",
                                                                                            }
                                                                                          ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "main-content",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "h4",
                                                                                        {
                                                                                          staticStyle:
                                                                                            {
                                                                                              margin:
                                                                                                "0",
                                                                                              padding:
                                                                                                "0 0 5",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "strong",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "\n                                                    " +
                                                                                                  _vm._s(
                                                                                                    _vm.getItemName(
                                                                                                      item,
                                                                                                      "te"
                                                                                                    )
                                                                                                  ) +
                                                                                                  "\n                                                    "
                                                                                              ),
                                                                                              _vm.selectedLanguage !=
                                                                                              "te"
                                                                                                ? _c(
                                                                                                    "span",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        "\n                                                      (" +
                                                                                                          _vm._s(
                                                                                                            _vm.getItemName(
                                                                                                              item,
                                                                                                              _vm.selectedLanguage
                                                                                                            )
                                                                                                          ) +
                                                                                                          ")\n                                                    "
                                                                                                      ),
                                                                                                    ]
                                                                                                  )
                                                                                                : _vm._e(),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "description-te",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "p",
                                                                                            {
                                                                                              staticClass:
                                                                                                "prescription-text",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "\n                                                    " +
                                                                                                  _vm._s(
                                                                                                    _vm.getLanguageDesc(
                                                                                                      item,
                                                                                                      "te"
                                                                                                    )
                                                                                                  ) +
                                                                                                  "\n                                                  "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm.selectedLanguage &&
                                                                                      _vm.selectedLanguage !==
                                                                                        "te"
                                                                                        ? _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "description-other-lang",
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "p",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "prescription-text",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                                    " +
                                                                                                      _vm._s(
                                                                                                        _vm.getLanguageDesc(
                                                                                                          item,
                                                                                                          _vm.selectedLanguage
                                                                                                        )
                                                                                                      ) +
                                                                                                      "\n                                                  "
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                !_vm.prescriptionobj
                                                  .modalresultPrescriptions
                                                  ? _c(
                                                      "table",
                                                      {
                                                        staticStyle: {
                                                          "border-bottom":
                                                            "0px solid rgb(225, 225, 225)",
                                                          background:
                                                            "rgb(250, 250, 250)",
                                                          width: "100%",
                                                          padding: "15px",
                                                        },
                                                        attrs: {
                                                          cellpadding: "0",
                                                          cellspacing: "0",
                                                        },
                                                      },
                                                      [
                                                        _c("tbody", [
                                                          _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                attrs: {
                                                                  colspan: "3",
                                                                  valign: "top",
                                                                  bgcolor:
                                                                    "#fafafa",
                                                                  align: "left",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "no-data-found p-5",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Noprescriptionshavebeensuggested."
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                        _vm.prescriptionFooterNote1 &&
                                        _vm.prescriptionFooterNote1
                                          .ehr_note_value
                                          ? _c("div", {
                                              staticClass:
                                                "prescriptionFooterNotehold",
                                              attrs: {
                                                id: "prescriptionFooterNote1",
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.prescriptionFooterNote1
                                                    .ehr_note_value
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "table",
                                          {
                                            staticStyle: {
                                              "border-bottom":
                                                "1px solid #d4d5d7",
                                            },
                                            attrs: {
                                              width: "100%",
                                              border: "0",
                                              cellspacing: "0",
                                              cellpadding: "0",
                                              align: "center",
                                            },
                                          },
                                          [
                                            _vm.Doctordetailsshow == true
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        padding:
                                                          "30px 0 15px 0",
                                                        margin: "0",
                                                      },
                                                      attrs: {
                                                        align: "right",
                                                        valign: "top",
                                                        bgcolor: "#FFFFFF",
                                                      },
                                                    },
                                                    [
                                                      _vm.fileUrl != ""
                                                        ? _c("img", {
                                                            attrs: {
                                                              src: _vm.fileUrl,
                                                              height: "120px",
                                                              width: "Auto",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm.prescriptionobj &&
                                                      _vm.prescriptionobj
                                                        .staffDetails &&
                                                      _vm.tenantId !=
                                                        "05c7079f-d889-4a40-8fac-0ae75c445c15"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                width: "100%",
                                                                "text-align":
                                                                  "right",
                                                                display:
                                                                  "block",
                                                                padding:
                                                                  "10px 0",
                                                              },
                                                              attrs: {
                                                                span: "",
                                                                id: "label_sign_doctorname",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .prescriptionobj
                                                                      .staffDetails
                                                                      .title
                                                                  ) +
                                                                  "\n                                " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .prescriptionobj
                                                                      .staffDetails
                                                                      .first_name
                                                                  ) +
                                                                  "\n                                " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .prescriptionobj
                                                                      .staffDetails
                                                                      .last_name
                                                                  ) +
                                                                  "\n                              "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.tenantId ==
                                                      "05c7079f-d889-4a40-8fac-0ae75c445c15"
                                                        ? _c(
                                                            "table",
                                                            {
                                                              attrs: {
                                                                width: "100%",
                                                              },
                                                            },
                                                            [_vm._m(2)]
                                                          )
                                                        : _vm._e(),
                                                      _vm.prescriptionobj
                                                        .footernote1
                                                        ? _c(
                                                            "table",
                                                            {
                                                              attrs: {
                                                                width: "100%",
                                                                cellpadding:
                                                                  "0",
                                                                cellspacing:
                                                                  "0",
                                                              },
                                                            },
                                                            [
                                                              _c("tr", [
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    attrs: {
                                                                      align:
                                                                        "center",
                                                                      valign:
                                                                        "top",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("p", {
                                                                      staticStyle:
                                                                        {
                                                                          margin:
                                                                            "10px 0 0",
                                                                          "font-size":
                                                                            "12px",
                                                                        },
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm
                                                                                .prescriptionobj
                                                                                .footernote1
                                                                            ),
                                                                        },
                                                                    }),
                                                                  ]
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _c("tfoot", [
                                  _c("tr", [
                                    _c("td", [
                                      _c("div", {
                                        class: _vm.printable_header
                                          ? "page-footer-space"
                                          : "page-footer-nospace",
                                      }),
                                    ]),
                                  ]),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                class: _vm.printable_header
                                  ? "page-footer"
                                  : "no-footer",
                              },
                              [
                                _vm.printable_header
                                  ? _c("table", { attrs: { width: "100%" } }, [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticStyle: { padding: "10px 0" },
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "body-text",
                                                staticStyle: {
                                                  color: "#212529",
                                                  "font-size": "13px",
                                                  "font-weight": "500",
                                                  "font-style": "normal",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Thisdocumentisdigitallysignedandhencenomanualsignatureisrequired"
                                                      )
                                                    ) +
                                                    "\n\n                      "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "13px",
                                                  color: "#aaa",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("Poweredby"))
                                                ),
                                              ]
                                            ),
                                            _vm._m(3),
                                            _vm._m(4),
                                          ]
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm.showhideemailpopup
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: {
                  id: "Sendemailp",
                  tabindex: "-1",
                  role: "dialog",
                  "aria-labelledby": "exampleModalCenterTitle",
                  "aria-hidden": "true",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-dialog grt-md",
                    staticStyle: {
                      width: "570px",
                      background: "#fff",
                      "border-radius": "3px",
                      "-webkit-border-radius": "3px",
                    },
                    attrs: { role: "document" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "modal-content",
                        staticStyle: { padding: "20px 50px" },
                      },
                      [
                        _c("div", { staticClass: "modal-header" }, [
                          _c("h5", { staticStyle: { margin: "0px auto" } }, [
                            _vm._v(_vm._s(_vm.$t("SendEmail"))),
                          ]),
                          _vm._m(5),
                        ]),
                        _c("div", { staticClass: "modal-body" }, [
                          _c(
                            "ul",
                            {
                              staticClass: "list-select",
                              staticStyle: { "margin-bottom": "0px" },
                            },
                            [
                              _vm._l(_vm.emaillist, function (item) {
                                return _c(
                                  "li",
                                  { key: item, staticClass: "data-hold" },
                                  [
                                    _c("span", [_vm._v(_vm._s(item))]),
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.removeEmail(item)
                                          },
                                        },
                                      },
                                      [_vm._v("X")]
                                    ),
                                  ]
                                )
                              }),
                              _c("li", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.customemail,
                                      expression: "customemail",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder:
                                      "Type in email address & press enter",
                                  },
                                  domProps: { value: _vm.customemail },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.addemail(_vm.customemail)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.customemail = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ],
                            2
                          ),
                          _vm.errorsemail
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "rgba(243, 69, 58, 0.8)",
                                    "font-size": "13px",
                                    "font-weight": "500",
                                    display: "block !important",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.errorsemail))]
                              )
                            : _vm._e(),
                        ]),
                        _vm.emaillist && _vm.emaillist.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "modal-footer",
                                staticStyle: { "padding-top": "0px" },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "primary-btn ripple pull-right",
                                    attrs: {
                                      type: "button",
                                      "data-dismiss": "modal",
                                      "aria-label": "Close",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.senddetailsoveremail()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Send")))]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "close-sec-hold" }, [
      _c(
        "button",
        {
          staticClass: "close pl-2",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { attrs: { "data-v-d4c013fa": "" } }, [
      _c(
        "td",
        {
          staticClass: "wrapper",
          attrs: {
            "data-v-d4c013fa": "",
            align: "left",
            valign: "top",
            bgcolor: "#FFFFFF",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: { "font-size": "28px", color: "rgb(0, 86, 224)" },
              attrs: { "data-v-d4c013fa": "" },
            },
            [
              _vm._v(
                "\n                                R\n                                "
              ),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "22px",
                    "font-weight": "500",
                    "margin-left": "-7px",
                  },
                  attrs: { "data-v-d4c013fa": "" },
                },
                [_vm._v("x")]
              ),
            ]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { align: "right" } }, [
        _c(
          "p",
          { staticStyle: { "margin-bottom": "5px", "font-weight": "500" } },
          [_vm._v("Dr. Swati Rajagopal, KMC #:61458")]
        ),
        _c("p", {
          staticStyle: { "margin-bottom": "5px", "font-weight": "500" },
        }),
        _c(
          "p",
          { staticStyle: { "margin-bottom": "5px", "font-weight": "500" } },
          [_vm._v("Arista Health Clinic")]
        ),
        _c(
          "p",
          { staticStyle: { "margin-bottom": "5px", "font-weight": "500" } },
          [_vm._v("Aster CMI Hospital")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticStyle: { "text-decoration": "none" },
        attrs: { href: "https://www.genamet.com/", target: "_blank" },
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              "font-size": "13px",
              color: "rgb(0, 86, 224)",
              "text-decoration": "none",
            },
          },
          [_vm._v("www.genamet.com")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticStyle: { "margin-right": "10px" }, attrs: { href: "#" } },
      [
        _c("img", {
          staticStyle: { "padding-top": "10px" },
          attrs: {
            src: "https://s3.amazonaws.com/genamet-static-uploads-dev/9c42767e-1559-426b-8c70-b54299e091dd/images/powered-genamet.png",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        staticStyle: { top: "10px" },
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }